import { Switch } from '@client/components/ui/switch';

interface AdminModeToggleProps {
  enabled: boolean;
  onToggle: (enabled: boolean) => void;
}

export function AdminModeToggle({ enabled, onToggle }: AdminModeToggleProps) {
  return (
    <div className="flex items-center gap-1.5">
      <Switch
        id="admin-mode"
        checked={enabled}
        onCheckedChange={onToggle}
        className="h-4 w-7 data-[state=checked]:bg-orange-500 [&>span]:h-3 [&>span]:w-3 [&>span]:data-[state=checked]:translate-x-3"
      />
      <label
        htmlFor="admin-mode"
        className={`cursor-pointer text-[10px] font-semibold uppercase tracking-wider ${
          enabled ? 'text-orange-900' : 'text-gray-500'
        }`}
      >
        Admin
      </label>
    </div>
  );
}
